/**
 * Copyright (c) Qwoach LLC 2025. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 20.11.25
 *
 */
export const CurrencyCodeEnum = Object.freeze({
	USD: "USD",
	EUR: "EUR",
	GBP: "GBP",
	NZD: "NZD",
	AUD: "AUD",
	CAD: "CAD",
	JPY: "JPY",
	CNY: "CNY",
	RUB: "RUB",
	INR: "INR",
	BRL: "BRL",
	PHP: "PHP",
})
